var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 23,
    viewBox: "0 0 22 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.3335 1.40234C7.71319 1.40234 8.021 1.71015 8.021 2.08984V4.83984C8.021 5.21954 7.71319 5.52734 7.3335 5.52734C6.9538 5.52734 6.646 5.21954 6.646 4.83984V2.08984C6.646 1.71015 6.9538 1.40234 7.3335 1.40234Z",
    fill: "#2E2E2E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.6665 1.40234C15.0462 1.40234 15.354 1.71015 15.354 2.08984V4.83984C15.354 5.21954 15.0462 5.52734 14.6665 5.52734C14.2868 5.52734 13.979 5.21954 13.979 4.83984V2.08984C13.979 1.71015 14.2868 1.40234 14.6665 1.40234Z",
    fill: "#2E2E2E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.521 8.58984C2.521 8.21015 2.8288 7.90234 3.2085 7.90234H18.7918C19.1715 7.90234 19.4793 8.21015 19.4793 8.58984C19.4793 8.96954 19.1715 9.27734 18.7918 9.27734H3.2085C2.8288 9.27734 2.521 8.96954 2.521 8.58984Z",
    fill: "#2E2E2E"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.34234 5.19307C3.755 5.82558 3.4375 6.77857 3.4375 8.04818V15.8398C3.4375 17.1095 3.755 18.0624 4.34234 18.695C4.92111 19.3182 5.8602 19.7357 7.33333 19.7357H14.6667C16.1398 19.7357 17.0789 19.3182 17.6577 18.695C18.245 18.0624 18.5625 17.1095 18.5625 15.8398V8.04818C18.5625 6.77857 18.245 5.82558 17.6577 5.19307C17.0789 4.56978 16.1398 4.15234 14.6667 4.15234H7.33333C5.8602 4.15234 4.92111 4.56978 4.34234 5.19307ZM3.33475 4.25745C4.24556 3.27657 5.59813 2.77734 7.33333 2.77734H14.6667C16.4019 2.77734 17.7544 3.27657 18.6653 4.25745C19.5675 5.2291 19.9375 6.56779 19.9375 8.04818V15.8398C19.9375 17.3202 19.5675 18.6589 18.6653 19.6306C17.7544 20.6114 16.4019 21.1107 14.6667 21.1107H7.33333C5.59813 21.1107 4.24556 20.6114 3.33475 19.6306C2.4325 18.6589 2.0625 17.3202 2.0625 15.8398V8.04818C2.0625 6.56779 2.4325 5.2291 3.33475 4.25745Z",
    fill: "#2E2E2E"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.4692 12.8151C13.4692 12.3088 13.8796 11.8984 14.3859 11.8984H14.3941C14.9004 11.8984 15.3108 12.3088 15.3108 12.8151C15.3108 13.3214 14.9004 13.7318 14.3941 13.7318H14.3859C13.8796 13.7318 13.4692 13.3214 13.4692 12.8151Z",
    fill: "#2E2E2E"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.4692 15.5651C13.4692 15.0588 13.8796 14.6484 14.3859 14.6484H14.3941C14.9004 14.6484 15.3108 15.0588 15.3108 15.5651C15.3108 16.0714 14.9004 16.4818 14.3941 16.4818H14.3859C13.8796 16.4818 13.4692 16.0714 13.4692 15.5651Z",
    fill: "#2E2E2E"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.0781 12.8151C10.0781 12.3088 10.4885 11.8984 10.9948 11.8984H11.003C11.5093 11.8984 11.9197 12.3088 11.9197 12.8151C11.9197 13.3214 11.5093 13.7318 11.003 13.7318H10.9948C10.4885 13.7318 10.0781 13.3214 10.0781 12.8151Z",
    fill: "#2E2E2E"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.0781 15.5651C10.0781 15.0588 10.4885 14.6484 10.9948 14.6484H11.003C11.5093 14.6484 11.9197 15.0588 11.9197 15.5651C11.9197 16.0714 11.5093 16.4818 11.003 16.4818H10.9948C10.4885 16.4818 10.0781 16.0714 10.0781 15.5651Z",
    fill: "#2E2E2E"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.6875 12.8151C6.6875 12.3088 7.09791 11.8984 7.60417 11.8984H7.6124C8.11866 11.8984 8.52907 12.3088 8.52907 12.8151C8.52907 13.3214 8.11866 13.7318 7.6124 13.7318H7.60417C7.09791 13.7318 6.6875 13.3214 6.6875 12.8151Z",
    fill: "#2E2E2E"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.6875 15.5651C6.6875 15.0588 7.09791 14.6484 7.60417 14.6484H7.6124C8.11866 14.6484 8.52907 15.0588 8.52907 15.5651C8.52907 16.0714 8.11866 16.4818 7.6124 16.4818H7.60417C7.09791 16.4818 6.6875 16.0714 6.6875 15.5651Z",
    fill: "#2E2E2E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.2ccbc006.svg";
export { ForwardRef as ReactComponent };